import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import batch from 'batch-promises';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { withStyles } from '@material-ui/core/styles';
import { merge, sum, set } from 'lodash';
import {
  Table,
  TableBody,
  Button,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Checkbox,
  TablePagination,
  FormControlLabel,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import moment from 'moment';
import isMobile from 'ismobilejs';
import { Done, Clear } from '@material-ui/icons';
import xlsx from 'xlsx';
import {
  dateTimeFormat,
  onceitProductUrl,
  valueFormat,
  columnProducts,
  GST_RATE,
} from './common/constants';
import { getProductVariances, updateProducts } from '../api/index';
import AlertDialog from './orders/AlertDialog';
import ProductsUpdate from './ProductsUpdate';
import { decorateData } from './common/ProductUtil';
import { transferToCSV } from './common/ProductUtil';

import Loading from './loading';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 50,
  },
  table: {
    width: '100%',
    minWidth: 600,
  },
  tableHeader: {
    textAlignLast: 'center',
  },
  tableCellHeader: {
    padding: '4px',
  },
  tableCell: {
    padding: '4px',
  },
  tableInSide: {
    width: '100%',
  },
  tableCellInside: {
    textAlign: 'left',
    border: 0,
    paddingLeft: '0px',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  input: {
    display: 'none',
  },
  label: {
    marginRight: '5px',
  },
  live: {
    color: 'green',
  },
  notlive: {
    color: 'red',
  },
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
  checkBox: {
    marginLeft: '10px',
    '&$checked': {
      color: 'blue',
    },
  },
  formControl: {
    marginRight: '5px',
    minWidth: 120,
  },
});

/**
 * Stock options
 * @type {{All: string, InStock: string, NoStock: string}}
 */
const stockOptions = {
  All: 'All',
  InStock: 'In Stock',
  NoStock: 'No Stock',
};

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        isLive: true,
        stock: Object.keys(stockOptions)[1], // Default is Instock
      },
      open: false,
      variantsToUpdate: {},
      isFetching: false,
      perPageOptions: [20, 50, 100],
      pageInfo: {
        pageSize: 20, // Defaults to 20 if not specified
        page: 0,
        order: 'asc',
        orderBy: 'created_at',
      },
      ranges: {
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [
          moment()
            .subtract(1, 'days')
            .startOf('day'),
          moment()
            .subtract(1, 'days')
            .endOf('day'),
        ],
        'This Week': [
          moment()
            .startOf('week')
            .add(1, 'day'),
          moment()
            .endOf('week')
            .add(1, 'day'),
        ],
        'Last Week': [
          moment()
            .subtract(1, 'week')
            .startOf('week')
            .add(1, 'day'),
          moment()
            .subtract(1, 'week')
            .endOf('week')
            .add(1, 'day'),
        ],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
          moment()
            .subtract(1, 'month')
            .startOf('month'),
          moment()
            .subtract(1, 'month')
            .endOf('month'),
        ],
        'Last 180 Days': [moment().subtract(180, 'day'), moment()],
      },
    };
    this.handleApply = this.handleApply.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleClearDate = this.handleClearDate.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleChangePageSize = this.handleChangePageSize.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.handleCloseUpdate = this.handleCloseUpdate.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.doExport = this.doExport.bind(this);
    this.doImport = this.doImport.bind(this);
    this.handleUploadRequest = this.handleUploadRequest.bind(this);
    this.handleStockChange = this.handleStockChange.bind(this);
  }

  componentWillMount() {
    this.handleFilter();
  }

  handleCheckbox() {
    const { filters } = this.state;
    const { pageInfo } = this.state;
    pageInfo.page = 0;
    if (!filters.isLive) {
      filters.isLive = true;
    } else {
      filters.isLive = false;
    }

    this.setState({
      filters,
      pageInfo,
    });
    this.handleFilter();
  }

  handleStockChange(e) {
    const { filters } = this.state;
    const { pageInfo } = this.state;
    pageInfo.page = 0;
    filters.stock = e.target.value;

    this.setState({
      filters,
      pageInfo,
    });
    this.handleFilter();
  }

  handleChange(event) {
    const { variantsToUpdate } = this.state;

    let { value } = event.target;
    if (value > 1000) {
      return;
    }
    if (value < 0 || value === '') {
      value = 0;
    }
    variantsToUpdate[event.target.getAttribute('data-field')] = value;

    this.setState({
      variantsToUpdate,
    });
  }

  handleUpdate(variants) {
    this.setState({ isFetching: true });
    let errors = [];
    const keys = Object.keys(variants);

    batch(3, keys, key => updateProducts({ variantId: key, quantity: variants[key] })).then(res => {
      res.forEach(result => {
        if (result.errors) {
          errors = [...errors, ...result.errors];
        }
      });
      if (errors.length > 0) {
        this.setState({ errors, isFetching: false });
      }
      this.setState({ isFetching: false, open: false });
    });
  }

  handleFilter() {
    this.setState({ isFetching: true }, () =>
      getProductVariances(merge(this.state.filters, this.state.pageInfo)).then(products => {
        if (products && products.data) {
          const mappedProducts = this.decorateResult(products.data);
          this.setState({
            isFetching: false,
            pageConfig: products.metadata,
            products: mappedProducts,
          });
        }
      })
    );
  }

  decorateResult(data) {
    return data.map(product => product).map(o => ({
      variants: o.productVariants,
      product: {
        id: o.id,
        title: [o.title],
        sku: o.code,
        createdAt: o.createdAt,
        isLive: o.isLive,
        cost: o.cost ? parseFloat(o.cost / GST_RATE).toFixed(2) : 0.0,
      },
    }));
  }

  doExport() {
    const fileName = `products - (${moment(new Date()).format('YYYY-MM-DD')}).csv`;
    const pageInfo = {
      pageSize: 2000,
      page: 0,
      order: 'asc',
      orderBy: 'created_at',
    };

    getProductVariances(merge(this.state.filters, pageInfo)).then(products => {
      const dataForExport = decorateData(products.data);
      dataForExport.unshift(columnProducts.map(item => item.label));
      const csvFile = transferToCSV(dataForExport);
      const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      this.setState({ isFetching: false });
    });
    return '';
  }

  handleUploadRequest() {
    this.setState({
      importInfo: [
        'Only CSV files are allowed for the import process.',
        'Please refrain from closing your browser until the import is complete.',
      ],
    });
  }

  importProducts() {
    this.fileInput.value = null;
    this.fileInput.click();
  }

  doImport(e) {
    let errors = [];
    this.setState({ isFetching: true });
    if (e.target.files.length > 1) {
      this.setState({
        isFetching: false,
        errors: [{ message: 'Sorry, you can only upload one file at a time.' }],
      });
      return;
    }
    const reader = new FileReader();
    reader.onload = ({ target: { result } }) => {
      let ws = null;
      try {
        ws = xlsx.read(result, { type: 'binary' }).Sheets.Sheet1;
      } catch (e) {
        this.setState({
          isFetching: false,
          errors: [{ message: 'Can not read the file, please double check is it a correct one.' }],
        });
        return;
      }
      const products = [];
      xlsx.utils.sheet_to_json(ws, { header: 1 }).forEach((row, i) => {
        if (i === 0) return;
        if (row[0] && Number(row[11]) >= 0 && Number(row[11]) <= 1000) {
          products.push({
            variantId: row[0],
            quantity: row[11],
          });
        } else if (!row[0]) {
          this.setState({
            isFetching: false,
            errors: [{ message: 'Id Column can not be empty' }],
          });
        } else if (!row[11] || Number(row[11]) < 0 || (Number(row[11]) && Number(row[11]) > 1000)) {
          this.setState({
            isFetching: false,
            errors: [{ message: 'Quantity can not be empty, less than 0 or more than 1000' }],
          });
        }
      });

      batch(2, products, product =>
        updateProducts({
          variantId: product.variantId,
          quantity: product.quantity,
        })
      ).then(res => {
        res.forEach(result => {
          if (result.errors) {
            errors = [...errors, ...result.errors];
          }
        });
        if (errors.length > 0) {
          this.setState({ errors, isFetching: false });
        }
        this.handleFilter();
      });
    };
    return reader.readAsBinaryString(e.target.files[0]);
  }

  handleClearDate() {
    const { filters } = this.state;
    delete filters.createdFrom;
    delete filters.createdTo;
    const { pageInfo } = this.state;
    pageInfo.page = 0;
    this.setState({
      filters,
      pageInfo,
    });
    this.handleFilter();
  }

  handleChangePage = (event, page) => {
    const { pageInfo } = this.state;
    pageInfo.page = page;
    this.setState({ pageInfo });
    this.handleFilter();
  };

  handleChangePageSize(event) {
    const { pageInfo } = this.state;
    pageInfo.pageSize = event.target.value;
    pageInfo.page = 0;
    this.setState({ pageInfo });
    this.handleFilter();
  }

  handleCloseAlert(type) {
    if (type === 'ok' && this.state.importInfo) {
      this.importProducts();
      this.setState({ importInfo: null });
    } else {
      this.setState({ errors: null, importInfo: null });
    }
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  handleCloseUpdate() {
    this.setState({ variantsToUpdate: {}, open: false });
  }

  handleApply(event, picker) {
    let startDate = null;
    let endDate = null;

    if (picker.startDate._isValid) {
      startDate = picker.startDate.format(dateTimeFormat);
      endDate = picker.endDate.format(dateTimeFormat);
    }
    const { filters } = this.state;
    filters.createdFrom = startDate;
    filters.createdTo = endDate;

    const { pageInfo } = this.state;
    pageInfo.page = 0;
    this.setState({
      filters,
      pageInfo,
    });
    this.handleFilter();
  }

  render() {
    const label = 'Created Date Range';
    let dateValue;
    if (this.state.filters.createdFrom || this.state.filters.createdTo) {
      dateValue = `${this.state.filters.createdFrom}-${this.state.filters.createdTo}`;
    } else {
      dateValue = '';
    }

    const locale = {
      format: dateTimeFormat,
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek(),
    };

    const { classes } = this.props;
    const { importInfo, errors, variantsToUpdate } = this.state;
    const keys = Object.keys(variantsToUpdate);

    let parameters =
      errors && errors.length > 0
        ? {
          title: 'Errors',
          message: errors.map(error => error.message),
          okButtonName: 'OK',
          handleClose: this.handleCloseAlert,
        }
        : null;
    if (!parameters) {
      parameters =
        importInfo && importInfo.length > 0
          ? {
            title: 'Import',
            message: importInfo,
            okButtonName: 'Import',
            cancelButtonName: 'Cancel',
            handleClose: this.handleCloseAlert,
          }
          : null;
    }
    return (
      <div className="product-container">
        <Grid className="spark-grid" lg={12} md={12} sm={12} xs={12}>
          <Toolbar>
            <div style={{ width: '100%' }}>
              <span className={classes.label}>Created Date: </span>
              <DateRangePicker
                timePicker
                showDropdowns
                autoApply
                locale={locale}
                // startDate={this.state.createdFrom}
                // endDate={this.state.createdTo}
                ranges={this.state.ranges}
                onApply={(event, picker) => this.handleApply(event, picker)}
              >
                <div className="input-group">
                  <input
                    type="text"
                    className="search-box"
                    value={dateValue}
                    placeholder={label}
                    style={{ width: isMobile.phone ? window.screen.width * 0.9 : '303px' }}
                  />
                </div>
              </DateRangePicker>

              {dateValue && (
                <button
                  className="close-icon-products"
                  type="reset"
                  onClick={() => this.handleClearDate()}
                />
              )}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.filters.isLive}
                    onChange={() => this.handleCheckbox()}
                    value="checkedB"
                    className={classes.checkBox}
                  />
                }
                label="Live Products"
              />
              <FormControl className={classes.formControl}>
                <InputLabel id="stock-select-label">Stock</InputLabel>
                <Select
                  labelId="stock-select-label"
                  id="stock-select"
                  value={this.state.filters.stock}
                  onChange={e => this.handleStockChange(e)}
                >
                  {Object.keys(stockOptions).map(key => (
                    <MenuItem value={key}>{stockOptions[key]}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <span className="float-right">
                <Button onClick={() => this.doExport()} className={classes.button} size="small">
                  Export
                </Button>
                <input
                  accept=".csv"
                  className={classes.input}
                  id="contained-button-file"
                  type="file"
                  ref={$ => {
                    this.fileInput = $;
                  }}
                  onChange={e => this.doImport(e)}
                />

                <Button
                  id="importButton"
                  size="small"
                  className={classes.button}
                  onClick={this.handleUploadRequest}
                >
                  Import
                </Button>
                <Button
                  onClick={() => this.handleClickOpen()}
                  className={classes.button}
                  size="small"
                >
                  Update
                </Button>
              </span>
            </div>
          </Toolbar>
          <Paper>
            {this.state.products ? (
              <Table className={classes.table} aria-labelledby="ordersTable">
                <TableHead className={classes.tableHeader}>
                  <TableRow>
                    {[
                      'SKU',
                      'Name',
                      'Live',
                      'Barcode',
                      'Colour',
                      'Size',
                      'Cost (GST excluded)',
                      'Sold Qty',
                      'InChecking Qty',
                      'Sold Amount',
                      'Avaliable Qty',
                      'Created Date',
                    ].map((prop, key) => (
                      <TableCell className={classes.tableCellHeader} key={key}>
                        {prop}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.products.map((prop, key) => (
                    <TableRow key={key}>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.product.sku}
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {' '}
                        <a href={`${onceitProductUrl}${prop.product.id}`}>
                          {prop.product.title.map((prop, key) => prop)}{' '}
                        </a>
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.product.isLive ? (
                          <Done className={classes.live} />
                        ) : (
                          <Clear className={classes.notlive} />
                        )}
                      </TableCell>

                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell
                                numeric
                                paddingNone
                                className={classes.tableCellInside}
                                style={{
                                  textAlign: 'center',
                                }}
                              >
                                {prop.barcode}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell numeric paddingNone className={classes.tableCellInside}>
                                {prop.productColour.colour}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>

                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell numeric paddingNone className={classes.tableCellInside}>
                                {prop.productSize.size}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        paddingNone
                        style={{
                          textAlign: 'right',
                        }}
                      >
                        ${prop.product.cost}
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell
                                numeric
                                paddingNone
                                className={classes.tableCellInside}
                                style={{
                                  textAlign: 'right',
                                }}
                              >
                                {prop.soldQuantity ? prop.soldQuantity : 0.0}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell
                                numeric
                                paddingNone
                                className={classes.tableCellInside}
                                style={{
                                  textAlign: 'right',
                                }}
                              >
                                {prop.inCheckingQuantity ? prop.inCheckingQuantity : 0.0}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell className={classes.tableCell} paddingNone>
                        {prop.variants.map((prop, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell
                                numeric
                                paddingNone
                                className={classes.tableCellInside}
                                style={{
                                  textAlign: 'right',
                                }}
                              >
                                ${prop.soldAmount ? prop.soldAmount : '0.00'}
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        paddingNone
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        {prop.variants.map((variant, key) => (
                          <table className={classes.tableInSide}>
                            <TableRow>
                              <TableCell
                                numeric
                                paddingNone
                                className={classes.tableCellInside}
                                style={{
                                  textAlign: 'center',
                                }}
                              >
                                <input
                                  min={0}
                                  max={1000}
                                  type="number"
                                  data-field={variant.id}
                                  onChange={this.handleChange}
                                  style={{ textAlign: 'center' }}
                                  value={
                                    keys.includes(String(variant.id))
                                      ? variantsToUpdate[variant.id]
                                      : variant.quantity || 0
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          </table>
                        ))}
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        paddingNone
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        {valueFormat({ date: true }, prop.product.createdAt)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : null}
            <TablePagination
              component="div"
              rowsPerPage={this.state.pageInfo.pageSize}
              count={
                this.state.pageConfig && this.state.pageConfig.totalCount
                  ? this.state.pageConfig.totalCount
                  : 0
              }
              page={this.state.pageInfo.page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              rowsPerPageOptions={this.state.perPageOptions}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={event => this.handleChangePageSize(event)}
            />
          </Paper>
          {parameters && <AlertDialog parameters={parameters} />}
          <ProductsUpdate
            open={this.state.open}
            handleClose={this.handleCloseUpdate}
            handleSubmit={this.handleUpdate}
            variants={variantsToUpdate}
          />
        </Grid>
        <div>{<Loading show={this.state.isFetching} text="Loading..." />}</div>
      </div>
    );
  }
}
export default withStyles(styles)(Products);



// WEBPACK FOOTER //
// ./src/components/Products.jsx